import { render } from "./DownloadFooter.vue?vue&type=template&id=5f7c71bc&scoped=true"
const script = {}

import "./DownloadFooter.vue?vue&type=style&index=0&id=5f7c71bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7c71bc"]])

export default __exports__